var _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockFailure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 82C70 85.1453 67.5798 87.7254 64.5 87.9795V93H63.5V87.9795C60.4202 87.7254 58 85.1453 58 82C58 78.6863 60.6863 76 64 76C67.3137 76 70 78.6863 70 82ZM69 82C69 84.7614 66.7614 87 64 87C61.2386 87 59 84.7614 59 82C59 79.2386 61.2386 77 64 77C66.7614 77 69 79.2386 69 82Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 54V38C41 25.2975 51.2975 15 64 15C76.7025 15 87 25.2975 87 38V54H96C100.418 54 104 57.5817 104 62V106C104 110.418 100.418 114 96 114H32C27.5817 114 24 110.418 24 106V62C24 57.5817 27.5817 54 32 54H41ZM86 38V54H42V38C42 25.8497 51.8497 16 64 16C76.1503 16 86 25.8497 86 38ZM32 55C28.134 55 25 58.134 25 62V106C25 109.866 28.134 113 32 113H96C99.866 113 103 109.866 103 106V62C103 58.134 99.866 55 96 55H32Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 108,
    r: 20,
    fill: "#FF248A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105 101.778L104.222 101L98 107.222L91.7778 101L91 101.778L97.2222 108L91 114.222L91.7778 115L98 108.778L104.222 115L105 114.222L98.7778 108L105 101.778Z",
    fill: "#351648"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFailure);
export default __webpack_public_path__ + "static/media/lock-failure.9bfe5640.svg";
export { ForwardRef as ReactComponent };